
// Vue
import { Component, Vue, Prop, Emit } from "vue-property-decorator";
import { namespace, } from "vuex-class";

// Types
import {
	RenewPasswordDetails,
	PasswordChangeResult
} from "@/store/user-management/types";
import { Pref } from "@/store/settings/types";
import { UserCredentials } from "@/services/api.service";

// Third Party
import { validationMixin } from "vuelidate";
import { required, sameAs, requiredIf } from "vuelidate/lib/validators";
import { isEqual } from "lodash";

// Components
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import vSelect from "vue-select";


// Namespaces
const UserManagement = namespace("userManagement");
const SettingsStore = namespace("settings");

enum complexityPrefs {
	complexityDisable = 157,
	maxConsecutive = 162,
	minUppercase = 263,
	minSpecialCharacters = 264,
	minLength = 265,
	minDigits = 266
}


@Component({
	mixins: [validationMixin],
	validations: {
		newPassword: {
			required,
			sameAs: sameAs(function() {
				return this.confirmPassword;
			})
		},
		confirmPassword: {
			required
		},
		oldPassword: {
			required
		}
	},
	components: {
		"v-select": vSelect,
		"vue-perfect-scrollbar": VuePerfectScrollbar
	}
})
export default class RenewPasswordModal extends Vue {
	@Prop({ default: false, type: Boolean }) visible: boolean;
	@Prop({ default: null, type: String }) providedUsername: string;
	@Prop({ default: null, type: String }) providedPassword: string;


	@SettingsStore.Action private loadPasswordComplexityPrefs: () => void;
	@SettingsStore.Getter("getAllPrefs") allPrefs: Pref[];

	@UserManagement.Action private renewUserPassword: (RenewPasswordDetails: RenewPasswordDetails) => Promise<PasswordChangeResult>;

	// Flags and Messages
	private showWarning: boolean = false;
	private warningMessage: string = null;
	private showSuccess: boolean = false;
	private complexityChecks: { [key: string]: number } = null;

	// Form details
	private username: string = null;
	private oldPassword: string = null;
	private newPassword: string = null;
	private confirmPassword: string = null;

	private async mounted() {

		this.username = this.providedUsername; //Move from mount to when modal is shown as mounted only works for the first instance
		this.oldPassword = this.providedPassword;
	}

	@Emit("close-modal")
	private closeModal() {
		this.username = null;
		this.oldPassword = null;
		this.newPassword = null;
		this.confirmPassword = null;
	}

	private async renewPassword() {
		const details : RenewPasswordDetails  = {
			Username : this.username,
			OldPassword : this.oldPassword,
			NewPassword : this.newPassword,
			ConfirmPassword : this.confirmPassword
		}
			
		let result = await this.renewUserPassword(details);
		this.complexityChecks = result.complexityChecks;

		if(result.successful)
		{
			const userCredentials: UserCredentials = {
				username: this.username,
				password: this.newPassword
			};
			// Login
			this.$emit("password-renewed", userCredentials);
			this.closeModal();
		}
		else {
			this.warningMessage = result.validationMessage
			this.showWarning = true
		}
	}
}
